const SET_IS_LOADING = "loadingState/SET_IS_LOADING";

export interface LoadingState {
  isPendingBoxSwap: boolean;
  isPendingPostPick: boolean;
  isPendingBatchPick: boolean;
  isPendingSkuPutaway: boolean;
  isRelocateBoxLoading: boolean;
  isFetchingStockData: boolean;
}

export const setIsLoading = (payload: { key: keyof LoadingState; value: boolean }) => {
  return {
    type: SET_IS_LOADING,
    payload,
  };
};

export const initialLoadingState: LoadingState = {
  isPendingBoxSwap: false,
  isPendingPostPick: false,
  isPendingBatchPick: false,
  isPendingSkuPutaway: false,
  isRelocateBoxLoading: false,
  isFetchingStockData: false,
};

const loadingStateReducer = (
  state = { ...initialLoadingState },
  action: { type: string; payload: { key: keyof LoadingState; value: boolean } }
): LoadingState => {
  switch (action.type) {
    case SET_IS_LOADING:
      return { ...state, [action.payload.key]: action.payload.value };
    default:
      return state;
  }
};

export default loadingStateReducer;
